import { sessionManager } from 'vue-infra';
import { has } from 'lodash';
import WidgetClient, { createClient, RESOURCES, RESOURCES_CONFIGURATION } from './WidgetClient';
import { WIDGET_DATA_DOMAIN,
  WIDGET_DOMAINS, WIDGET_EXPLORE_FIELD, WIDGET_EXPLORE_OBJECT,
  WIDGET_EXPLORER_DOMAIN,
  WIDGET_SEARCH_PHRASE } from '../common/consts';

const RESOURCES_SW = Object.freeze({
  ...RESOURCES,
  WIDGET_DELETE_CONNECTION: 'WidgetDeleteConnection',
  WIDGET_EXPLORER: 'WidgetExplorer',
  WIDGET_OBJECT: 'WidgetObject',
  WIDGET_FIELD: 'WidgetField',
  WIDGET_SEARCH: 'WidgetSearch',
});

const RESOURCES_CONFIGURATION_SW = Object.freeze({
  ...RESOURCES_CONFIGURATION,
  [RESOURCES_SW.WIDGET_DELETE_CONNECTION]: {
    ALLOWED_METHODS: [WidgetClient.HTTP_METHODS.DELETE],
    URL_KEY: () => 'WIDGET.DeleteConnection',
  },
  [RESOURCES_SW.WIDGET_EXPLORER]: {
    ALLOWED_METHODS: [WidgetClient.HTTP_METHODS.GET],
    URL_KEY: () => 'WIDGET.Explorer',
  },
  [RESOURCES_SW.WIDGET_OBJECT]: {
    ALLOWED_METHODS: [WidgetClient.HTTP_METHODS.GET],
    URL_KEY: () => 'WIDGET.Object',
  },
  [RESOURCES_SW.WIDGET_FIELD]: {
    ALLOWED_METHODS: [WidgetClient.HTTP_METHODS.GET],
    URL_KEY: () => 'WIDGET.Field',
  },
  [RESOURCES_SW.WIDGET_SEARCH]: {
    ALLOWED_METHODS: [WidgetClient.HTTP_METHODS.GET],
    URL_KEY: () => 'WIDGET.Search',
  },
});

class SalesforceWidgetClient extends WidgetClient {
  constructor({
    resource,
    contextName,
    ...options
  }) {
    super({
      resource,
      contextName,
      client: createClient(options, resource, contextName, setSalesforceDomains, RESOURCES_CONFIGURATION_SW),
      ...options,
    });
  }
}

SalesforceWidgetClient.RESOURCES = RESOURCES_SW;
SalesforceWidgetClient.RESOURCES_CONFIGURATION = RESOURCES_CONFIGURATION_SW;

function setSalesforceDomains(urlResolver, options) {
  let accountZone = sessionManager.getAccountZone();
  if (accountZone === 'qa' || !has(WIDGET_DOMAINS, accountZone)) {
    accountZone = 'z0';
  }
  const exploreObject = options.exploreObject || 'unknown';
  const exploreField = options.exploreField || 'unknown';
  const searchPhrase = options.searchPhrase || 'unknown';

  const widgetExplorerDomain = WIDGET_DOMAINS[accountZone][WIDGET_EXPLORER_DOMAIN];
  urlResolver.addConfigValue(WIDGET_EXPLORER_DOMAIN, widgetExplorerDomain);
  urlResolver.addConfigValue(WIDGET_EXPLORE_OBJECT, exploreObject);
  urlResolver.addConfigValue(WIDGET_EXPLORE_FIELD, exploreField);
  const widgetDataDomain = WIDGET_DOMAINS[accountZone][WIDGET_DATA_DOMAIN];
  urlResolver.addConfigValue(WIDGET_DATA_DOMAIN, widgetDataDomain);
  urlResolver.addConfigValue(WIDGET_SEARCH_PHRASE, searchPhrase);
}

export default SalesforceWidgetClient;
